module.exports = __webpack_public_path__ + "img/61f74c5bb16bb4bd1d20c93c8fc8e10d.png";